// components/servicesSection.jsx
import React, { useState } from 'react';
import './styles/servicesSection.css';

const ServicesSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const services = [
    {
      title: "Brand Strategy",
      description: "Comprehensive brand development and positioning to create lasting market impact.",
      details: [
        "Brand Identity Design",
        "Market Research & Analysis",
        "Positioning Strategy",
        "Brand Guidelines"
      ]
    },
    {
      title: "UI/UX Design",
      description: "Beautiful, intuitive interfaces backed by research and user testing for optimal results.",
      details: [
        "User Research & Testing",
        "Wireframing & Prototyping",
        "Visual Design",
        "Design Systems"
      ]
    },
    {
      title: "Development",
      description: "Custom web and mobile applications built with cutting-edge technologies.",
      details: [
        "React & Next.js",
        "Node.js Backend",
        "Mobile Apps (iOS/Android)",
        "Cloud Deployment"
      ]
    },
    {
      title: "Motion Design",
      description: "Dynamic animations and interactions that bring your brand to life.",
      details: [
        "2D/3D Animation",
        "Micro-interactions",
        "Video Production",
        "Interactive Experiences"
      ]
    },
    {
      title: "Digital Marketing",
      description: "Data-driven marketing strategies that maximize ROI and accelerate growth across all channels.",
      details: [
        "Paid Advertising (PPC & Social)",
        "SEO & Organic Growth",
        "App Store Optimization (ASO)",
        "Analytics & Performance Tracking"
      ]
    }
  ];

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="services" className="services-section">
      <div className="services-container">
        <h2 className="services-title">Services</h2>
        <p className="services-subtitle">
          Comprehensive solutions for modern digital challenges
        </p>

        <div className="accordion-container">
          {services.map((service, index) => (
            <div 
              key={index} 
              className={`accordion-item ${openIndex === index ? 'open' : ''}`}
            >
              <div 
                className="accordion-header"
                onClick={() => toggleAccordion(index)}
              >
                <h3 className="accordion-title">{service.title}</h3>
                <div className="accordion-icon">
                  <span className="icon-line icon-line-horizontal"></span>
                  <span className="icon-line icon-line-vertical"></span>
                </div>
              </div>
              <div className="accordion-content">
                <p className="accordion-description">{service.description}</p>
                <ul className="accordion-details">
                  {service.details.map((detail, idx) => (
                    <li key={idx}>{detail}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;